// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2RKRI","productName":"Table_productName__22R7n"};